<template>
    <v-flex :class="['back__button', 'mx-auto', containerClass]">
        <div @click="backHandler">
            <button type="button" class="btn btn-back" >
                <svg width="14" height="12" viewBox="0 0 14 12">
                    <path d="M12.6756 5.68751H2.10725L6.41849 1.53345C6.54519 1.41136 6.54519 1.21361 6.41849 1.09156C6.29179 0.96948 6.08655 0.96948 5.95988 1.09156L1.09502 5.77906C0.968325 5.90114 0.968325 6.0989 1.09502 6.22095L5.95988 10.9084C6.02322 10.9695 6.10622 11 6.1892 11C6.27218 11 6.35515 10.9695 6.41852 10.9084C6.54522 10.7864 6.54522 10.5886 6.41852 10.4666L2.10725 6.31253H12.6757C12.8549 6.31253 13 6.17275 13 6.00002C13 5.82728 12.8549 5.68751 12.6756 5.68751Z"
                    />
                </svg>
                <span>{{currentText}}</span>
            </button>
        </div>

    </v-flex>
</template>

<script>
    export default {
        computed: {
            currentRoute() {
                const ROUTE_NAME = this.$route.name;
                return ROUTE_NAME;
//                const url = this.$route.path.split('/');
//                return url[url.length - 1]
            },
            backButton() {
                return this.$t(`studio.${this.currentRoute}.guess_backButton`)
            },
            currentText() {
                return this.$t(`button.${this.defaultText}`)
            },
        },

        props: {
            containerClass: {
                type: String,
                required: false,
                default: 'lg-12'
            },
            defaultRoute: {
                type: String,
                required: false,
                default: '/studios/dashboard'
            },
            defaultText: {
                type: String,
                required: false,
                default: 'back-to-dashboard',
            }
        },

        methods: {
            backHandler() {
                this.$router.push(`${this.defaultRoute}`);
//                this.$router.go(-1);
            }
        }
    }
</script>

<style lang="sass" scoped>
    .back__button
        padding: 0
        +xs
            margin: 0!important
</style>
